export const mergeTeamPresence = (employee, update) => {
  if (!update) return employee;
  const { employeeId, ...fields } = update;
  const callState = fields.callState ?? employee.callState;
  return {
    ...employee,
    ...Object.fromEntries(Object.entries(fields).filter(([, value]) => value !== undefined)),
    callState,
    presence: ['on_call', 'ringing'].includes(callState) ? 'busy' : fields.presence ?? employee.presence
  };
};
